import React, { useState } from "react";
import ColorPicker from "../../../components/ColorPicker";

const ThemeTab = ({ updateSpinningWheelTabData,spinningWheelTabData }) => {
    const [backgroundColor, setBackgroundColor] = useState(spinningWheelTabData.background_color);
    const [textColor, setTextColor] = useState(spinningWheelTabData.text_color);
    const [accentColor, setAccentColor] = useState(spinningWheelTabData.accent_color);
    const [emailFieldErrorColor, setEmailFieldErrorColor] = useState(spinningWheelTabData.email_field_error_color);

    // Handlers Background Color Change
    const handleBackgroundColorChange = (color) => {
        setBackgroundColor(color.hex);
        updateSpinningWheelTabData("background_color", color.hex);
    };

    // Handlers Text Color Change
    const handleTextColorChange = (color) => {
        setTextColor(color.hex);
        updateSpinningWheelTabData("text_color", color.hex);
    };

    // Handlers Accent Color Change
    const handleAccentColorChange = (color) => {
        setAccentColor(color.hex);
        updateSpinningWheelTabData("accent_color", color.hex);
    };

    // Handlers Email Field Error Color Change
    const handleEmailFieldErrorColorChange = (color) => {
        setEmailFieldErrorColor(color.hex);
        updateSpinningWheelTabData("email_field_error_color", color.hex);
    };

    return (
        <div className="side-baar-inner-setting">
            <span>Theme</span> 
            <div className="side-baar-box-header mb-3">
                <div className="box-header-row">
                    <span>Background Color</span>
                    <div className="color-pikr-box">
                        <ColorPicker color={backgroundColor} setColor={setBackgroundColor} onChangeComplete={handleBackgroundColorChange}/>
                    </div>
                </div>
                <div className="box-header-row">
                    <span>Text Color</span>
                    <div className="color-pikr-box">
                        <ColorPicker color={textColor} setColor={setTextColor} onChangeComplete={handleTextColorChange}/>
                    </div>
                </div>
                <div className="box-header-row">
                    <span>Accent Color</span>
                    <div className="color-pikr-box">
                        <ColorPicker color={accentColor} setColor={setAccentColor} onChangeComplete={handleAccentColorChange}/>
                    </div>
                </div>
                <div className="box-header-row">
                    <span>Email Field Error Color</span>
                    <div className="color-pikr-box">
                        <ColorPicker color={emailFieldErrorColor} setColor={setEmailFieldErrorColor} onChangeComplete={handleEmailFieldErrorColorChange}/>
                    </div>
                </div>
            </div>
             <div className="side-baar-box-header">
                <div className="box-header-row">
                    <span>Font</span>
                    <em>Default</em>
                </div>
            </div>
        </div>
    );
};

export default ThemeTab;